import { render, staticRenderFns } from "./MyLomIndividual.vue?vue&type=template&id=43b9b197"
import script from "./MyLomIndividual.vue?vue&type=script&lang=js"
export * from "./MyLomIndividual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports